<!-- <div class="row mt-2 no-gutters">
  <div class="col">
    <small>
      <a class="text-secondary pointer" [routerLink]="['/dashboard']">Admin Console</a>&nbsp;/
      <a class="text-secondary pointer" [routerLink]="['/accounts']">Accounts</a>&nbsp;/
    </small>
    <small *ngIf="account">
      <a class="text-secondary pointer" [routerLink]="['/account']">{{account.name}}</a>&nbsp;/
      <a class="text-secondary pointer" [routerLink]="['/account/vehicles']">Vehicles</a>&nbsp;/
      <a class="text-secondary">Enrollment Status</a>
    </small>
  </div>
</div> -->

<!--NEW CODE-->

<div class="modal fade" id="enrollmentStatus" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-full modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title">Enrollment Status</h5>
        <button id="closeEnrollmentStatus" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetEnrollVehicles()">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!--NEW CODE-->
        <div class="row">
          <div class="col-sm-12">
            <div class="card bg-light p-2">
              <div class="row">
                <div class="col-12">
                  <div class="text-secondary mb-2 font13-400">Select the below values to filter the data</div>
                  <div>
                    <label>Select Period:&nbsp;&nbsp;</label>
                    <label>&nbsp;&nbsp;&nbsp;From:&nbsp;</label>
                    <p-calendar class="ml-2 date-time-input" name="fromDate" [readonlyInput]="true" [showTime]="true"
                      [maxDate]="selectedToDate" [(ngModel)]="selectedFromDate">
                    </p-calendar>
                    <label>&nbsp;&nbsp;To:&nbsp;</label>
                    <p-calendar class="ml-2 date-time-input" name="toDate" [readonlyInput]="true" [showTime]="true"
                      [minDate]="selectedFromDate" [maxDate]="today" [(ngModel)]="selectedToDate"></p-calendar>

                    <select class="btn-165 ml-2" id="enrollmentStatusDropdown" name="enrollmentStatusDropdown"
                      [(ngModel)]="selectedEnrollmentStatus" (ngModelChange)="onEnrollmentStatusChange()"
                      #enrollmentStatusModel="ngModel">
                      <option [ngValue]="null">Enrollment Status</option>
                      <option [ngValue]="item.key" *ngFor="let item of enrollmentStatus | keyvalue;">{{item.key |
                        customText}}
                      </option>
                    </select>

                    <button class="ml-2 btn btn-outline-danger btn-sm pt-0 pb-0" (click)="getEnrollmentStatusData()">
                      <span class="maroon"><i class="fa fa-angle-double-right"></i></span></button>
                  </div>
                </div>
                <!-- <div class="col-4 text-right my-auto"><button class="btn btn-primary border" (click)="onEnrollVehicles()">Enroll
            Now</button></div> -->
              </div>
            </div>
          </div>

          <div class="col-12 mt-3 table-responsive no-gutters">
            <table class="table table-striped tbl-scrollable">
              <thead class="thead-light">
                <tr>
                  <th width="7%" scope="col" class="text-center">
                    <!-- <button class="btn btn-outline-danger py-0 delete-button" [disabled]="selectedVehicles.length < 1"><i class="fa fa-trash"></i></button> -->
                  </th>
                  <th scope="col" class="px-0">
                    <ng-template #rt let-r="result" let-t="term">
                      <ngb-highlight [result]="r.vin" [term]="t"></ngb-highlight>
                    </ng-template>
                    <input id="typeahead-template" type="text" class="form-control type-ahead-search" placeholder="VIN"
                      (selectItem)="onVehicleSelected($event)" [(ngModel)]="searchVin"  [ngbTypeahead]="searchVehicle" [resultTemplate]="rt"
                      [inputFormatter]="formatter" [editable]='true' />
                  </th>
                  <th scope="col">Status</th>
                  <!-- <th scope="col">Step</th>
                  <th scope="col" width="25%">Message</th> -->
                  <th scope="col" class="px-0">Last Attempt Time</th>
                  <th scope="col" class="px-0">Next Attempt Time</th>
                </tr>
              </thead>
              <!-- <tbody *ngIf="vehicleList && vehicleList.length>0; else noVehicles"
                class="scroll-height-screenHeight hide-x-scroll" id="accordionEnrollmentStatus"> -->
              <tbody *ngIf="vehicleList && vehicleList.length>0; else noVehicles"
                class="scroll-height-screenHeight hide-x-scroll">
                <ng-container *ngFor="let vehicle of vehicleList; let i = index">
                  <!-- <tr class="pointer" data-toggle="collapse" [attr.data-target]="'#enrollment-status-' + i"
                    aria-expanded="false" aria-controls="'enrollment-status-' + i"> -->
                  <tr>
                    <th scope="row" width="7%" class="text-center pr-0">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" name="enrollVehicleStatusCheckbox" class="custom-control-input"
                          [checked]="isVehicleStatusSelected(vehicle.vin)"
                          (change)="onVehicleStatusSelectionChange($event.target.checked, vehicle)" id="enrollVehicleStatus_{{i}}">
                        <label class="custom-control-label" for="enrollVehicleStatus_{{i}}"></label>
                      </div>
                    </th>
                    <td scope="row" class="px-0">{{vehicle.vin}}</td>
                    <td scope="row">{{vehicle.status | customText}}</td>
                    <!-- <td scope="row">{{getEnrollmentStateMessage(vehicle.lastFailedState)}}</td>
                    <td scope="row" width="25%">
                      <span *ngIf="vehicle.error && vehicle.error.description">{{vehicle.error.description}}</span>
                    </td> -->
                    <td scope="row" class="px-0">{{vehicle.lastAttemptTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                    <td scope="row" class="px-0">{{vehicle.nextAttemptTime | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                  </tr>

                  <!-- <tr [attr.id]="'enrollment-status-' + i" class="collapse" data-parent="#accordionEnrollmentStatus">
                    <td class="p-0" colspan="7">
                      <div class="card">
                        <div *ngIf="vehicle.attempts && vehicle.attempts.length > 0" class="row m-2">
                          <div class="col-sm-12 font13-600 m-2">Attempts</div>
                          <div class="col-sm-12 mt-2 col-md table-responsive">
                            <table class="table">
                              <thead class="thead-light cursor-pointer">
                                <tr>
                                  <th scope="col">Attempted At</th>
                                  <th scope="col" width="40%">Error</th>
                                  <th scope="col">State</th>
                                  <th scope="col">Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngFor="let attempt of vehicle.attempts;">
                                  <tr>
                                    <td>{{attempt.attemptedAt | date: utilService.countryData.dateFormat + ' ' + utilService.countryData.timeFormat : utilService.countryData.timezone}}</td>
                                    <td width="40%">
                                      <span
                                        *ngIf="attempt.failureResponse && attempt.failureResponse.errorMessage">{{attempt.failureResponse.errorMessage}}</span>
                                    </td>
                                    <td>{{getEnrollmentStateMessage(attempt.endState)}}</td>
                                    <td>{{attempt.status | customText}}</td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr> -->
                </ng-container>
              </tbody>
            </table>
          </div>
          <!-- <div class="col-12 pt-2 pb-4 text-right">
    <button class="btn btn-primary border" (click)="onEnrollVehicles()">Enroll Now</button>
  </div> -->
        </div>
        <ng-template #noVehicles>
          <div class="row text-center my-5 text-muted no-gutters">
            <div class="col">
              <h3>No vehicle available</h3>
            </div>
          </div>
        </ng-template>

        <!--NEW CODE-->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal"
          (click)="resetEnrollVehicles()">CANCEL</button>
        <!-- <button class="btn btn-primary" (click)="onEnrollVehicles()"> -->
        <button class="btn btn-primary" (click)="updateEnrollmentStatus()" [disabled]="!(vehicleList != null && vehicleList.length > 0)">
          <span *ngIf="isEnrollmentStatus">
            Enroll Now
          </span>
          <span *ngIf="!isEnrollmentStatus">
            Unenroll Now
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
<!--NEW CODE-->

<app-enrollment-errors modalId="enrollNowErrorsModal" modalOpenButtonId="openEnrollNowErrorsModal" modalCloseButtonId="closeEnrollNowErrorsModal" 
  modalHeader="Failed Vehicle(s)"  [enrollmentErrors]="enrollmentErrors"></app-enrollment-errors>